"use strict";
import { isDelegatedEOA } from "features/smartWallet/delegation/isDelegatedEOA";
import { ensure0xHex } from "utils/hex";
export function createDelegationService(ctx) {
  return {
    getIsAddressDelegated: async (input) => {
      const bytecode = ensure0xHex(await ctx.delegationRepository.getWalletBytecode(input));
      const isDelegatedEOAOutput = isDelegatedEOA({
        bytecode
      });
      if (isDelegatedEOAOutput.isDelegated && isDelegatedEOAOutput.delegateTo) {
        ctx.onDelegationDetected?.({ address: isDelegatedEOAOutput.delegateTo, chainId: input.chainId });
        return {
          isDelegated: true,
          delegatedAddress: isDelegatedEOAOutput.delegateTo
        };
      } else {
        return {
          isDelegated: false,
          delegatedAddress: null
        };
      }
    }
  };
}
